import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconGlobeComponent } from "./med-icon-globe.component";

@NgModule({
  declarations: [
    MedIconGlobeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconGlobeComponent,
  ],
})
export class MedIconGlobeModule { }
